import React from 'react';
import { Link } from 'react-router-dom';

class MainBanner extends React.Component {
    render(){
        return (
            <div className="page-title-area item-bg1">
                <div className="container">
                    <h1>Generate You Amazing NFT</h1>
                    <span>Generate your art by upload your layers in folders</span>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li>Generate NFT</li>
                    </ul>
                </div>
            </div>
        );
    }
}
 
export default MainBanner;